module.exports = __webpack_public_path__ + "r-v3/img/sticker_22_icon.309d505f.svg";